/** Neon cyberpunk line-art icons — matches /icon reference set */

export const GAP_ICONS = [
  "/images/gap-icons/search-play.jpg",
  "/images/gap-icons/team-alert.jpg",
  "/images/gap-icons/report-analytics.jpg",
];

export const WHY_NEON_ICONS = {
  brain: "/images/neon-icons/brain-cyan.png",
  trend: "/images/neon-icons/trend-green.png",
  target: "/images/neon-icons/target-amber.png",
  zap: "/images/neon-icons/zap-violet.png",
};

export const CAPABILITY_NEON_ICONS = {
  brain: "/images/neon-icons/brain-cyan.png",
  search: "/images/neon-icons/search-cyan.png",
  trend: "/images/neon-icons/trend-green.png",
  zap: "/images/neon-icons/zap-violet.png",
  layers: "/images/neon-icons/layers-blue.png",
  lock: "/images/neon-icons/lock-green.png",
};

export const TRUST_NEON_ICONS = [
  "/images/neon-icons/trust-onprem-green.png",
  "/images/neon-icons/trust-shield-cyan.png",
  "/images/neon-icons/trust-eye-amber.png",
  "/images/neon-icons/trust-cpu-violet.png",
];
